/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectdataWithRelations } from '../models/projectdata-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ProjectdataControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectdataControllerUploadMounterFile
   */
  static readonly ProjectdataControllerUploadMounterFilePath = '/Uploadfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadMounterFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadMounterFile$Response(params: {
    context?: HttpContext

    /**
     * Request body for multipart/form-data based file upload
     */
    body: {
'file'?: Blob;
}
  }
): Observable<StrictHttpResponse<Array<ProjectdataWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectdataControllerService.ProjectdataControllerUploadMounterFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectdataWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `UploadMounterFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadMounterFile(params: {
    context?: HttpContext

    /**
     * Request body for multipart/form-data based file upload
     */
    body: {
'file'?: Blob;
}
  }
): Observable<Array<ProjectdataWithRelations>> {

    return this.UploadMounterFile$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectdataWithRelations>>) => r.body as Array<ProjectdataWithRelations>)
    );
  }

}
